<div>
    <ds-tag [tagInput]="tagConfig" (btnClick)="onTagRemoved($event)"></ds-tag>
</div>